module.exports = __webpack_public_path__ + "static/img/kids_1.c29848c2.png";